import './target-skill.ajscss';

import { hasChange } from '@commons/util/helper/helper';
import { copy, IChangesObject, IComponentController, IComponentOptions } from 'angular';

import { Skill } from '@contact/upgrade';

import templateUrl from './target-skill.html';

const MODULE_NAME = 'transferTargetSkill';

class TransferTargetSkillCtrl implements IComponentController {
  public name = MODULE_NAME;

  // binding
  public eventTargetChange: Function;
  public skills: Skill[];

  // internal properties
  public targetSkills: Skill[] = [];

  $onChanges(changesObj: { [property: string]: IChangesObject }) {
    // skills changed
    if (hasChange(changesObj['skills'])) {
      this.skills = copy(changesObj['skills'].currentValue);
    }
  }

  onTargetChange(): void {
    this.eventTargetChange({ $event: { target: this.targetSkills } });
  }
}

export class TransferTargetSkill implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    skills: '<',
    eventTargetChange: '&',
  };
  controller = [TransferTargetSkillCtrl];
}

export default MODULE_NAME;
